import { translations } from './useTranslate'

const useLanguage = (getLanguagePreference) => {
  const browserLanguage = window.navigator.language.slice(0, 2)
  const defaultLanguage = browserLanguage && translations[browserLanguage] ? browserLanguage : 'en'
  return getLanguagePreference ? getLanguagePreference() || defaultLanguage : defaultLanguage
}

export default useLanguage
